import React from 'react';
import { useTranslation } from 'react-i18next';
import './FeedbackDialog.css';

const FeedbackDialog = ({ story, isOpen, onClose, onSubmit }) => {
    const [feedback, setFeedback] = React.useState("");
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleSubmit = () => {
        if (feedback.trim()) {
            onSubmit(story._id, feedback);
            setFeedback("");
            onClose();
        }
    };

    return (
        <div className="feedback-overlay">
            <div className="feedback-dialog">
                <img src={story.coverImage} alt={story.title} className="story-cover" />
                <h2>{story.title}</h2>
                <textarea
                    placeholder={t('publicStories.writeFeedbackHere')}
                    defaultValue={story.userFeedbackText}
                    onChange={(e) => setFeedback(e.target.value)}
                    maxLength={500}
                    required
                />
                <div className="dialog-buttons">
                    <button className="submit-btn" onClick={handleSubmit}>{t('publicStories.feedbackSubmit')}</button>
                    <button className="cancel-btn" onClick={onClose}>{t('publicStories.feedbackCancel')}</button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackDialog;
